import './AccountTitleDetailView.scss'
import React from 'react'
import { ListGroup } from '../../molecules'
import { ListItem } from '../../atoms'
import Cell from '../../templates/Cell'
import r from '../../../util/Renderer'
import toAccountTitleDetailEditView from '../../../action/account_title_detail/toAccountTitleDetailEditView'
import LocalArea from '../../templates/LocalArea'
import { NavigationDrawer, NormalButton } from 'ui-library/dist/external/components'

function AccountTitleDetailListView(props) {
  const toolbar = { label: '補助科目管理', items: props.accountMenu }
  const details = props.details ? props.details : []
  const costTypes = type => {
    const costTypes = {
      unrelated: 'なし',
      variable: '変動費',
      fixed: '固定費'
    }
    return costTypes[type] || ''
  }

  return (
    <div id="AccountTitleDetails">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />
      <LocalArea>
        <div className="LocalArea--right">
          <NormalButton onClick={e => toAccountTitleDetailEditView()}>新規作成</NormalButton>
        </div>
      </LocalArea>
      <div className="AccountTitle">
        <div className="AccountTitles__List">
          {r.renderIfOrElse(details.size > 0)(
            <ListGroup border="underline" className="ItemGroup">
              {details.map((item, id) => (
                <ListItem key={id} className="ListItem">
                  <Cell className="position">{item.position}</Cell>
                  <Cell className="titleGroupName">{item.account_title_group_name}</Cell>
                  <Cell className="titleGroupName">{item.account_title_name}</Cell>
                  <Cell className="name">{item.name}</Cell>
                  <Cell className="cost_type">{costTypes(item.cost_type)}</Cell>
                  <Cell className="action">
                    <NormalButton onClick={e => toAccountTitleDetailEditView(item.id)}>編集</NormalButton>
                  </Cell>
                </ListItem>
              ))}
            </ListGroup>
          )(
            <div className="row">
              <div className="col-12">
                <div className="AccountTitles__List--empty">
                  <div className="inner">
                    <div className="message">登録されている勘定科目はありません</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
export default AccountTitleDetailListView
